import { Button, Modal, ModalFooter, ModalHeader } from "modules/common";
import React from "react";
import { TermsOfUseContent } from "./TermsOfUseContent";

interface Props {
  isVisible: boolean;
  toggleModal: () => void;
}

export const TermsOfUseModal: React.FC<Props> = ({
  isVisible,
  toggleModal,
}) => {
  return (
    <Modal
      isActive={isVisible}
      onClose={toggleModal}
      modalHeader={
        <ModalHeader
          onClose={toggleModal}
          title="Uvjeti korištenja"
          isLoading={false}
        />
      }
      modalFooter={
        <ModalFooter>
          <Button
            type="button"
            size="small"
            variant="warning"
            onClick={toggleModal}
          >
            <span>Zatvori</span>
          </Button>
        </ModalFooter>
      }
    >
      <TermsOfUseContent />
    </Modal>
  );
};
